module.exports = __webpack_public_path__ + "img/hs_ev_einleitung_11.40c3d22a.png";